import { getApiEndpoint } from '../../../config/api';

// Fetch real report data for a property over a date range.
// `reportId` is currently used to derive the end date (e.g. 'last-30' or an ISO date).
// The backend returns the exact shape the report template consumes.
export async function fetchReport(propertyId, reportId) {
  const now = new Date();
  let end = now;

  // Support reportId values like "2026-04" (YYYY-MM) → end of that month
  if (reportId && /^\d{4}-\d{2}$/.test(reportId)) {
    const [y, m] = reportId.split('-').map(Number);
    end = new Date(y, m, 0, 23, 59, 59); // last day of month
  } else if (reportId && /^\d{4}-\d{2}-\d{2}$/.test(reportId)) {
    end = new Date(reportId + 'T23:59:59');
  }

  const start = new Date(end.getTime() - 30 * 24 * 60 * 60 * 1000);

  const url = getApiEndpoint(
    `/api/properties/${propertyId}/report?start=${encodeURIComponent(start.toISOString())}&end=${encodeURIComponent(end.toISOString())}`
  );
  const token = localStorage.getItem('token');
  const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
  if (!res.ok) throw new Error(`Report fetch failed: ${res.status}`);
  return res.json();
}
